class LoyaltyCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.dotsContainer = this.querySelector('[data-carousel-dots]');
    this.controls = this.querySelector('.loyalty-carousel__controls');
    this.previousButton = this.querySelector('[data-carousel-previous]');
    this.nextButton = this.querySelector('[data-carousel-next]');

    if (!this.listening) {
      this.previousButton?.addEventListener('click', () => this.goTo(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
      this.dotsContainer?.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-carousel-dot]');
        if (dot) this.goTo(this.dots.indexOf(dot));
      });
      this.listening = true;
    }

    this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
      root: this.track,
      threshold: 0.6,
    });
    this.refresh();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  refresh() {
    this.observer.disconnect();
    this.slides = Array.from(this.track.children);
    this.slides.forEach((slide) => this.observer.observe(slide));
    this.index = 0;
    this.renderDots();
    if (this.controls) this.controls.hidden = this.slides.length < 2;
    this.update();
  }

  renderDots() {
    if (!this.dotsContainer) {
      this.dots = [];
      return;
    }
    const template = this.dotsContainer.querySelector('[data-carousel-dot]');
    const label = this.dotsContainer.dataset.dotLabel ?? '';
    const dots = this.slides.map((slide, index) => {
      const dot = template ? template.cloneNode(true) : document.createElement('button');
      dot.type = 'button';
      dot.className = 'loyalty-carousel__dot';
      dot.dataset.carouselDot = '';
      dot.setAttribute('aria-label', label.replace('[index]', String(index + 1)));
      return dot;
    });
    this.dotsContainer.replaceChildren(...dots);
    this.dots = dots;
  }

  onIntersect(entries) {
    const visible = entries.find((entry) => entry.isIntersecting);
    if (!visible) return;
    this.index = this.slides.indexOf(visible.target);
    this.update();
  }

  goTo(index, { smooth = true } = {}) {
    const slide = this.slides[Math.max(0, Math.min(index, this.slides.length - 1))];
    if (!slide) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const scrollPadding = parseFloat(getComputedStyle(this.track).scrollPaddingInlineStart) || 0;
    this.track.scrollTo({
      left: slide.offsetLeft - scrollPadding,
      behavior: smooth && !reduceMotion ? 'smooth' : 'auto',
    });
  }

  update() {
    this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
    if (this.previousButton) this.previousButton.disabled = this.index === 0;
    if (this.nextButton) this.nextButton.disabled = this.index >= this.slides.length - 1;
  }
}

if (!customElements.get('loyalty-carousel')) {
  customElements.define('loyalty-carousel', LoyaltyCarousel);
}
